// Lightweight HTTP wrapper for fetch with base URL, headers and optional auth token.
// Keeps HTTP concerns in one place and returned response handling consistent.

export async function request(path, options = {}) {
  const base = '';
  const url = path.startsWith('http') ? path : base + path;

  const headers = Object.assign({ 'Accept': 'application/json' }, options.headers || {});

  // attach token if present
  try {
    const token = window.localStorage.getItem('authToken');
    if (token) headers['Authorization'] = `Bearer ${token}`;
  } catch (e) {
    // ignore localStorage errors
  }

  const opts = Object.assign({}, options, { headers });

  const res = await fetch(url, opts);
  return res;
}

export async function get(path, options = {}) {
  return request(path, Object.assign({}, options, { method: 'GET' }));
}

export async function post(path, body, options = {}) {
  const headers = Object.assign({ 'Content-Type': 'application/json' }, options.headers || {});
  return request(path, Object.assign({}, options, { method: 'POST', headers, body: JSON.stringify(body) }));
}
